import Component from './components/TaxType';

export default Component;
